import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { List } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import fetch from '../hooks/fetch';
import { fetchRoleActions } from '../actions';
import RoleActionsContent from './RoleActionsContent';

const RoleActionsList = ({
  category,
  code,
  fetchData,
  readStatus,
}) => {
  fetch.useFetchRoleActions(fetchData, category, code, readStatus, false);
  return (
    <List className="aridhia-role-actions">
      <List.Item>
        <List.Header>
          <FormattedMessage id="role.actions.title" />
        </List.Header>
        <RoleActionsContent category={category} code={code} />
      </List.Item>
    </List>
  );
};

const mapStateToProps = ({
  roles: { roles },
}, { category, code }) => {
  const { roleActions } = findResult(roles, category, code);

  return {
    readStatus: roleActions.readStatus,
  };
};

const mapDispatchToProps = {
  fetchData: fetchRoleActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleActionsList);
